import moment from "moment";
import { apiData } from "../utils/api";
import { getUserId } from "../utils/storage";

class FieldAgentAPI {
  // Add Field Agent API
  async addFieldAgentAPI(values) {
    const req = {
      url: "api/v1/auth/register/agent",
      method: "POST",
      data: {
        email: values.email,
        phone: values.phone.toString(),
        role: "Field-Agent", // ADMIN, DSA, Field Agent
      },
    };

    return await apiData(req);
  }

  // Get Field Agent Users
  async getFieldAgentUser(page) {
    const req = {
      url: `api/v1/user/dsa/list?role=Field-Agent&pageSize=10&pageNumber=${page}`,
      method: "GET",
      data: {},
    };

    return await apiData(req);
  }

  // Feild Agent Dashboard Report
  async fieldAgentReportAPI(id) {
    const userId = id || getUserId();

    const dataParams = new URLSearchParams(window.location.search);

    const startDate = dataParams.get("startDate") || moment(new Date()).format("YYYY-MM-01");
    const endDate = dataParams.get("endDate") || moment(new Date()).format("YYYY-MM-DD");
    const leadFilter = dataParams.get("leadFilter") || "leads";

    const req = {
      url: `api/v1/dsa/merchant/report?userId=${userId}&startDate=${startDate}&endDate=${endDate}&leadFilter=${leadFilter}`,
      method: "GET",
      data: {},
    };

    return await apiData(req);
  }

  // Field Agent Lead Lists
  async fieldAgentLeadListAPI(id, page) {
    const userId = id || getUserId();

    const params = new URLSearchParams(window.location.search);

    const startDate = params.get("startDate") || moment(new Date()).format("YYYY-MM-01");
    const endDate = params.get("endDate") || moment(new Date()).format("YYYY-MM-DD");
    const status = params.get("status") || "All";
    const leadFilter = params.get("leadFilter") || "leads";

    const req = {
      url: `api/v1/dsa/merchant/list?userId=${userId}&startDate=${startDate}&endDate=${endDate}&pageNumber=${page}&pageSize=100&status=${status}&leadFilter=${leadFilter}`,
      method: "GET",
      data: {},
    };

    return await apiData(req);
  }
}

export default FieldAgentAPI;
